<template>
  <div>
  <div class="box" style="padding-bottom:50px">
    <b-field label="Idegen">
      <div>{{orig}}</div>
    </b-field>
    <b-field label="Magyar">
      <div>{{hun}}</div>
    </b-field>
    <b-field label="Meriam-Webster">
      <div v-html="webster"></div>
    </b-field>
    <b-field v-if='lang=="eng"' label="Examples">
      <div v-html="_example"></div>
    </b-field>

    <audio v-if='lang=="eng"' id='breProns'><source :src="prons1" type="audio/mpeg"></audio>
    <audio v-if='lang=="eng"' id='ameProns'><source :src="prons2" type="audio/mpeg"></audio>
  </div>
    <div style="position: fixed; height: 50px; bottom:0;width:100%;background-color:white;margin: 5px">
      <div class="buttons is-pulled-left">
        <b-button @click="_cancel">Vissza</b-button>
        <b-button v-if='lang=="eng"' @click="play('breProns')" icon-right="headphones"></b-button>
        <b-button v-if='lang=="eng"' @click="play('ameProns')" icon-right="headphones"></b-button>
        <b-button  @click="edit" icon-right="edit"></b-button>
      </div>
      <div class="buttons is-pulled-right">
        <b-button @click="_back" :disabled="idx == 0" icon-right="chevron-left"></b-button>
        <b-button @click="_forward" :disabled="idx == list.length-1" icon-right="chevron-right"></b-button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Show',
  data: function() {
    return {
      lang : '',
      orig : '',
      hun : '',
      transl : '',
      mono : '',
      example : '',
      id : 0,
      idx : 0,
      prons1 : '',
      prons2 : '',
    }
  },
  computed: {
    webster() {
      return this.mono.replace(/\n/g, '<br />')
    },
    _example() {return this.example.replace(/\n/g, '<br />')},
    list() { return this.$store.state.list}
  },
  watch: {
    $route() {
      this.refresh()
    }
  },
  methods: {
    _cancel: function() {
      this.$router.go('-1')
    },
    refresh: function() {
      this.idx = this.$store.getters.idx(this.$route.params.id)
      var data = this.list[this.idx]
      this.id = data.id
      this.orig = data.orig
      this.hun = data.hun
      this.lang = data.lang
      this.mono = data.mono
      this.example = data.example
      this.prons1 = 'https://d27ucmmhxk51xv.cloudfront.net/media/english/breProns/' + data.prons1
      this.prons2 = 'https://d27ucmmhxk51xv.cloudfront.net/media/english/ameProns/' + data.prons2
    },
    _back: function() {
      if (this.idx > 0){
        this.$router.replace('/show/' + this.list[this.idx - 1].id)
      }
    },
    _forward: function() {
      if (this.idx < this.list.length-1){
        this.$router.replace('/show/' + this.list[this.idx + 1].id)
      }
    },
    play(sel) {
      document.getElementById(sel).load()
      document.getElementById(sel).play()
    },
    edit() {
      this.$router.push('/edit/' + this.id)
    },
    _keyup(event) {
      switch(event.key) {
        case "a": 
          this.play('ameProns')
          break
        case "e":
          this.play('breProns')
          break
        case "ArrowLeft" :
          this._back()
          break
        case "ArrowRight" :
          this._forward()
          break
        case "Escape" :
          this._cancel()
          break
        case "Enter" :
          this.edit()
          break

      }
    }
  },
  created() {
    this.refresh()
    window.addEventListener('keyup', this._keyup)
  },
  destroyed() {
    window.removeEventListener('keyup', this._keyup)
  }
}
</script>

<style scoped>
</style>
